import { acceptHMRUpdate, defineStore } from 'pinia'

import { type CaseSourceName, type CaseType } from '~/types.ts'

export const useSource = defineStore('source', {
  state: () => ({
    fields: {} as Record<CaseSourceName, string[]>,
    keyFields: {} as Record<CaseSourceName, string[]>,
    perType: {} as Record<CaseType, CaseSourceName[]>,
    labels: {} as Record<CaseSourceName, string>,
  }),

  getters: {
    availableNames: (state): CaseSourceName[] => {
      return (Object.keys(state.labels) as CaseSourceName[]).filter((source) => source !== 'other' || stores.dataSources.isSourceActive(source))
    },

    availableLabels(): Partial<Record<CaseSourceName, string>> {
      return Object.fromEntries(this.availableNames.map((source) => [source, this.labels[source]]))
    },

    availablePerType(): Record<CaseType, CaseSourceName[]> {
      return Object.fromEntries(Object.entries(this.perType).map(([type, sources]) => [type, sources.filter((source) => this.availableNames.includes(source))])) as Record<
        CaseType,
        CaseSourceName[]
      >
    },
  },
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useSource, import.meta.hot))
}
